import { Container } from '../ui/Container'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'

const stages = [
  { n: '01', title: 'Understand', description: 'Find the real problem.' },
  { n: '02', title: 'Design', description: 'Turn the problem into a clear solution.' },
  { n: '03', title: 'Build', description: 'Develop the technology behind it.' },
  { n: '04', title: 'Evolve', description: 'Improve it as the business grows.' },
]

export function HowWeWork() {
  return (
    <section className="border-b border-ink/10 bg-bone py-24 md:py-32">
      <Container>
        <Reveal>
          <Eyebrow>How we work</Eyebrow>
          <h2 className="mt-6 max-w-2xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
            From problem to product.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl bg-ink/10 sm:grid-cols-2 lg:grid-cols-4">
          {stages.map((stage, i) => (
            <Reveal key={stage.n} delay={i * 100}>
              <div className="group relative flex h-full flex-col justify-between bg-bone p-8 transition-colors duration-300 hover:bg-paper">
                <span className="font-display text-sm text-signal">{stage.n}</span>
                <div className="mt-16">
                  <h3 className="font-display text-2xl font-semibold tracking-tight">{stage.title}</h3>
                  <p className="mt-2 text-sm text-graphite">{stage.description}</p>
                </div>
                {i < stages.length - 1 ? (
                  <span className="absolute right-0 top-1/2 hidden h-px w-4 -translate-y-1/2 translate-x-full bg-ink/15 lg:block" />
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}
